import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'

import {
    TabCompetencia,
    useAberturaFechamentoCompetenciaOutletContext,
} from 'pages/FechamentoCompetencia.context'
import { useParams } from 'react-router-dom'
import { FormularioDetalhes } from '../forms/Detalhes'

export function ModalDetalhes() {
    const { id } = useParams()
    const { tab, aberturas, fechamentos } =
        useAberturaFechamentoCompetenciaOutletContext()

    const row: any =
        tab === TabCompetencia.ABERTURA
            ? aberturas?.find(a => a.id === Number(id))
            : fechamentos?.find(a => a.id === Number(id))

    if (!row) return null

    return (
        <Dialog.Root
            defaultValues={{
                status: row.status,
                usuario: row.Usuario.email,
                horaAbertura: row.horaAbertura,
                justificativa: row.justificativa,
                horaFechamento: row.horaFechamento,
                competencia: dayjs(row.competencia).format('MM/YYYY'),
                dataAbertura: dayjs(row.dataAbertura).format('DD/MM/YYYY'),
                dataFechamento: dayjs(row.dataFechamento).format('DD/MM/YYYY'),
            }}
        >
            <Dialog.Title>Detalhes</Dialog.Title>
            <Dialog.Content>
                <FormularioDetalhes tab={tab} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
